define('mypages/accountlimitations/depositLimitPopup',['jquery', 'module'], function ($, module) {
	'use strict';

	function onShowDepositLimitPopUp($element, jsonString) {

		var $depositLimit = $('#deposit-limit');

		var limitType = $($element.parent().parent()).attr('id');

		var limitTypeToHeaderMap = {};
		limitTypeToHeaderMap['deposit-daily'] = jsonString.HEADER_DAILY_DEPOSIT_LIMIT;
		limitTypeToHeaderMap['deposit-weekly'] =  jsonString.HEADER_WEEKLY_DEPOSIT_LIMIT;
		limitTypeToHeaderMap['deposit-monthly'] = jsonString.HEADER_MONTHLY_DEPOSIT_LIMIT;

		window.top.showModalPanel(limitTypeToHeaderMap[limitType], $depositLimit.html(), null, null, null, true, true);

		setupButtonClickHandlers($element, limitType);

	}

	function handleDepositLimitChangeResponse(response){
		if (response.RESULT === 'OK') {
			if(parent.modalPanel !== null){
				parent.modalPanel.hide();
			}
			var panelHeaderResponseSuccess = undefined;
			var inButtonCode = undefined;
			var icon = null;
			window.top.showInfoMessage(response.HEADER, response.TEXT, response.BUTTON_TEXT, null, null, null,
				panelHeaderResponseSuccess, inButtonCode);
			window.top.loadUrl(null, 'bodyframe');
		} else if (response.RESULT == 'RG_LIMIT_ERROR') {
			window.top.showInfoMessage(response.ERROR_HEADER, response.ERROR_MESSAGE, response.BUTTON_TEXT, true, null, null,
				response.ERROR_PANEL_HEADER);
		}
	}


	function setupButtonClickHandlers($element, limitType) {

		var $modalPanel = $('#modalPanel', parent.document);

		var isAddMode = false;
		if($element.hasClass('addbutton')) {
			isAddMode = true;
		}
		var $removeLimit = $modalPanel.find('#remove_limit');
		if(isAddMode){
			$removeLimit.hide();
		} else{
			$removeLimit.show();
		}

		var sendButton = $modalPanel.find('#btn-send');
		sendButton.off().on('click', function(){
			onAddOrEditDepositLimit($modalPanel, limitType, isAddMode);
			return false;
		});

		var removeLimitButton = $modalPanel.find('#remove_limit');
		removeLimitButton.off().on('click', function(){
			removeLimit(limitType);
			return false;
		});

		var cancelButton = $modalPanel.find('#btn-cancel');
		cancelButton.off().on('click', function () {
			onCancelConfirmationDepositLimit();
			return false;
		});

		disableNonNumericCharacters($modalPanel);
		setupValidatationOnKeyUp($modalPanel);
	}

	function disableNonNumericCharacters($modalPanel) {
		var $element = $modalPanel.find('#DEPOSIT_LIMIT_VALUE');
		$element.keypress(function (event) {
			var BACKSPACE = 8;
			var TAB = 9;
			var chr = String.fromCharCode(event.which);
			if ('1234567890'.indexOf(chr) < 0 && [BACKSPACE, TAB].indexOf(event.keyCode) < 0) {
				return false;
			}
		});
	}

	function setupValidatationOnKeyUp($modalPanel){
		var $depositLimitElement = $modalPanel.find('#DEPOSIT_LIMIT_VALUE');
		$depositLimitElement.keyup(function(){
			validateDepositLimitValue($depositLimitElement, $modalPanel);
		});
	}

	function removeLimit(limitType) {
		$.post('/pp?flow=ResponsibleGamingDepositLimitRemove', {limitType: limitType}, function (response) {
			handleDepositLimitChangeResponse(response);
		});
	}


	function onCancelConfirmationDepositLimit() {
		parent.modalPanel.hide();
	}

	function onAddOrEditDepositLimit($modalPanel, limitType, isAddMode) {

		var $depositLimitElement = $modalPanel.find('#DEPOSIT_LIMIT_VALUE');
		var depositLimitValue = $depositLimitElement.val();

		var isValid = validateDepositLimitValue($depositLimitElement, $modalPanel);

		if(isValid){

			var flow = 'ResponsibleGamingDepositLimitUpdate';
			if(isAddMode){
				flow = 'ResponsibleGamingDepositLimitAdd';
			}

			$.post('/pp?flow=' + flow, {depositLimitValue: depositLimitValue, limitType: limitType}, function (response) {
				handleDepositLimitChangeResponse(response);
			});
		}
	}

	function validateDepositLimitValue($depositLimitElement, $modalPanel) {
		var depositLimitValue = $depositLimitElement.val();
		var $errorElement = $modalPanel.find('#DEPOSIT_LIMIT_VALUE-error');
		var isValid = isLimitValueValid(depositLimitValue);
		if(isValid === true){
			$errorElement.hide();
		} else{
			$errorElement.show();
		}

		return isValid;
	}

	function isLimitValueValid(depositLimitValue){
		if (isNaN(depositLimitValue) || depositLimitValue < 1) {
			return false;
		} else{
			var depositLimitFloatValue = parseFloat(depositLimitValue);
			if(depositLimitFloatValue < 10000000){
				return true;
			} else{
				return false;
			}
		}
	}


	var depositLimitPopup = {};
	depositLimitPopup.onShowDepositLimitPopUp = onShowDepositLimitPopUp;
	depositLimitPopup.onCancelConfirmationDepositLimit = onCancelConfirmationDepositLimit;
	depositLimitPopup.onAddDepositLimit = onAddOrEditDepositLimit;
	depositLimitPopup.handleDepositLimitChangeResponse = handleDepositLimitChangeResponse;

	return depositLimitPopup;

});


